import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Betriebsart } from '../../../../projects/kiene-core/src/lib/components/stammdaten/vvvo/classes/betriebsart';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import {
    ArrayTableColumn,
    KieneBooleanTableColumn,
    TableColumn,
    TextTableColumn,
} from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { AddBetriebsartDialogComponent } from '../../dialogs/add-betriebsart-dialog/add-betriebsart-dialog.component';

import { EditBetriebsartDialogComponent } from '../../dialogs/edit-betriebsart-dialog/edit-betriebsart-dialog.component';
import { BetriebsartPreiseUndRabattDialogComponent } from './betriebsart-preise-und-rabatt-dialog/betriebsart-preise-und-rabatt-dialog.component';
import { BetriebsartenTierartenDialogComponent } from './betriebsarten-tierarten-dialog/betriebsarten-tierarten-dialog.component';
import { ProduktionsabschnitteComponent } from './produktionsabschnitte/produktionsabschnitte.component';

@Component({
    selector: 'kiene-betriebsarten',
    templateUrl: './betriebsarten.component.html',
    styleUrls: ['./betriebsarten.component.scss'],
})
export class BetriebsartenComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        private messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneTableService,
        private localStorageService: LocalStorageService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Betriebsarten';
        this.tableDescriptor.uniqueIdentifier = 'Betriebsarten';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'betriebsart/';
        this.tableDescriptor.route = '/administration/betriebsarten/';
        this.tableDescriptor.nameOfIdField = 'betriebsart_id';
        this.tableDescriptor.searchPlaceholder = 'Betriebsarten durchsuchen';
        this.tableDescriptor.columns.push(new TableColumn('betriebsart_id', 'ID'));
        this.tableDescriptor.columns.push(new TextTableColumn('bezeichnung', 'Bezeichnung'));
        this.tableDescriptor.columns.push(new KieneBooleanTableColumn('kaelbermast', 'Kälbermast'));
        this.tableDescriptor.columns.push(new KieneBooleanTableColumn('ohrmarke', 'Ohrmarke'));
        if (this.localStorageService.hasPermission(1604)) {
            this.tableDescriptor.columns.push(new TableColumn('verkaufspreis', 'Verkaufspreis'));
            this.tableDescriptor.columns.push(new TableColumn('rabatt', 'Rabatt %'));
        }
        this.tableDescriptor.columns.push(new KieneBooleanTableColumn('qs', 'QS Meldung'));
        this.tableDescriptor.columns.push(new TableColumn('qs_schluessel', 'QS Schlüssel'));
        this.tableDescriptor.columns.push(new KieneBooleanTableColumn('hit', 'HIT Meldung'));
        this.tableDescriptor.columns.push(
            new ArrayTableColumn('produktionsabschnitte', 'Produktionsabschnitte', ['produktionsabschnitt']),
        );
        this.tableDescriptor.columns.push(new ArrayTableColumn('tierarten', 'Tierarten', ['bezeichnung']));
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = false;

        this.tableDescriptor.options.push(new TableOption(this.openEditDialog.bind(this), 'bearbeiten', 'edit', 3103));
        this.tableDescriptor.options.push(
            new TableOption(this.produktionsabschnitteBearbeiten.bind(this), 'Produktionsabschnitte', 'segment', 3113),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.tierartenBearbeiten.bind(this), 'Tierarten', 'cruelty_free', 3113),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.openPreiseRabattDialog.bind(this), 'Preise und Rabatt', 'euro', 3113),
        );

        this.tableDescriptor.initialSortColumn = 'betriebsart_id';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.addVoid = this.openAddDialog.bind(this);
    }

    produktionsabschnitteBearbeiten(betriebsart: Betriebsart) {
        this.dialog
            .open(ProduktionsabschnitteComponent, { data: betriebsart, disableClose: true })
            .afterClosed()
            .subscribe(() => {
                this.api.reload();
            });
    }

    tierartenBearbeiten(betriebsart: Betriebsart) {
        const dialog = this.dialog.open(BetriebsartenTierartenDialogComponent, {
            data: betriebsart,
            disableClose: true,
        });

        dialog.afterClosed().subscribe(response => {
            if (response) {
                this.api.reload();
            }
        });
    }

    openAddDialog() {
        const dialog = this.dialog.open(AddBetriebsartDialogComponent, { width: '40%', minWidth: '400px' });

        dialog.afterClosed().subscribe(response => {
            if (response) {
                this.saveBetriebsart(response);
            }
        });
    }

    openEditDialog(betriebsart: Betriebsart) {
        const dialog = this.dialog.open(EditBetriebsartDialogComponent, {
            width: '40%',
            minWidth: '400px',
            data: { betriebsart: betriebsart },
        });

        dialog.afterClosed().subscribe(response => {
            if (response) {
                this.saveBetriebsart(response);
            }
        });
    }

    saveBetriebsart(betriebsart: Betriebsart) {
        this.api.updateEntity(this.apiBaseUrl + 'betriebsart/update.php', betriebsart).subscribe(
            () => {
                this.messageService.infoMessage(
                    'Die Betriebsart ' + betriebsart.bezeichnung + ' wurde erfolgreich gespeichert!',
                );
                this.api.reload();
            },
            error => {
                this.messageService.errorMessage('Die Betriebsart konnte nicht gespeichert werden! ', error);
            },
        );
    }

    private openPreiseRabattDialog(betriebsart: Betriebsart) {
        const dialogRef = this.dialog.open(BetriebsartPreiseUndRabattDialogComponent, { data: betriebsart });
        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                this.api.reload();
            }
        });
    }
}
